
import React from "react";
import { Check } from "lucide-react";

const AdditionalLocationsSection: React.FC = () => {
  return (
    <section className="section-spacing bg-joerg-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Vielfältige Möglichkeiten
          </span>
          <h2 className="animate-fade-in" style={{ animationDelay: '100ms' }}>
            Weitere inspirierende Orte für dein Coaching
          </h2>
          <p className="mt-6 text-joerg-600 animate-fade-in" style={{ animationDelay: '200ms' }}>
            Neben dem Rothsee biete ich auch Coaching-Erlebnisse an anderen besonderen Orten an.
            Die Umgebung wird dabei individuell auf deine Bedürfnisse und Themen abgestimmt.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-2xl shadow-soft animate-fade-in">
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 text-primary mb-6 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mountain"><path d="m8 3 4 8 5-5 5 15H2z"/></svg>
            </div>
            
            <h3 className="text-xl font-semibold text-center">Fränkische Schweiz</h3>
            
            <p className="mt-4 text-joerg-600">
              Malerische Landschaft mit Felsen, Höhlen und Wäldern – ideal für tiefgreifende Perspektivwechsel und Coaching-Gespräche in einzigartiger Naturkulisse.
            </p>
            
            <div className="mt-6 space-y-3">
              <div className="flex items-start gap-3">
                <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-joerg-600">
                  Abwechslungsreiche Wanderwege für Walk & Talk
                </span>
              </div>
              <div className="flex items-start gap-3">
                <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-joerg-600">
                  Einzigartige Aussichtspunkte für Reflexionsphasen
                </span>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-2xl shadow-soft animate-fade-in" style={{ animationDelay: '150ms' }}>
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 text-primary mb-6 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-tree"><path d="M12 22v-7l-2-2"/><path d="M17 8v4l2 2"/><path d="M19 17h-3"/><path d="M8 11V7l-2-2"/><path d="M5 8h3"/><path d="M12 7h4"/></svg>
            </div>
            
            <h3 className="text-xl font-semibold text-center">Nürnberger Stadtwald</h3>
            
            <p className="mt-4 text-joerg-600">
              Leicht erreichbar und doch mitten in der Natur – die großen Waldgebiete rund um Nürnberg bieten eine ruhige Umgebung für konzentrierte Coaching-Gespräche.
            </p>
            
            <div className="mt-6 space-y-3">
              <div className="flex items-start gap-3">
                <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-joerg-600">
                  Gut ausgebaute Waldwege für jeden Fitnessgrad
                </span>
              </div>
              <div className="flex items-start gap-3">
                <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-joerg-600">
                  Stressreduktion durch das beruhigende Waldambiente
                </span>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-2xl shadow-soft animate-fade-in" style={{ animationDelay: '300ms' }}>
            <div className="flex items-center justify-center h-12 w-12 rounded-full bg-primary/10 text-primary mb-6 mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map"><polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/><line x1="9" x2="9" y1="3" y2="18"/><line x1="15" x2="15" y1="6" y2="21"/></svg>
            </div>
            
            <h3 className="text-xl font-semibold text-center">Individueller Wunschort</h3>
            
            <p className="mt-4 text-joerg-600">
              Hast du einen besonderen Ort, der für dich persönlich bedeutsam ist? Gerne gestalte ich das Coaching auch an einem Ort deiner Wahl, der zu deinen Themen und Zielen passt.
            </p>
            
            <div className="mt-6 space-y-3">
              <div className="flex items-start gap-3">
                <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-joerg-600">
                  Coaching in persönlich bedeutsamer Umgebung
                </span>
              </div>
              <div className="flex items-start gap-3">
                <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-joerg-600">
                  Flexibilität bei der Terminplanung und Ortswahl
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdditionalLocationsSection;
